import React from 'react';
import { Button } from '@salesforce/design-system-react';

/**
 * WalkthroughControls Component
 * Navigation controls for the walkthrough (Previous, Next, Close buttons and progress indicator)
 */
const WalkthroughControls = ({
  currentStepIndex,
  totalSteps,
  isFirstStep,
  isLastStep,
  onPrevious,
  onNext,
  onClose
}) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      {/* Progress indicator */}
      <div style={{
        marginBottom: '12px',
        fontSize: '12px',
        color: '#706e6b',
        textAlign: 'center'
      }}>
        Step {currentStepIndex + 1} of {totalSteps}
      </div>

      {/* Navigation buttons */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '8px'
      }}>
        {/* Previous button */}
        {!isFirstStep && (
          <Button
            label="Previous"
            onClick={(e) => {
              e.stopPropagation();
              onPrevious();
            }}
            variant="neutral"
          />
        )}
        {isFirstStep && <div style={{ width: '80px' }} />}

        {/* Next/Done button */}
        <div style={{ display: 'flex', gap: '8px' }}>
          {!isLastStep ? (
            <Button
              label="Next"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onNext();
              }}
              variant="brand"
            />
          ) : (
            <Button
              label="Done"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onClose();
              }}
              variant="brand"
            />
          )}

          {/* Close button */}
          <Button
            label="Close"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            variant="neutral"
          />
        </div>
      </div>
    </div>
  );
};

export default WalkthroughControls;
